export default {
  path: "app_configs",
  name: "astrology_app_configs",
  meta: {
    label: "App configs",
  },
  component() {
    return import("@/components/Astrology/AppConfigs/AppConfigsList/AppConfigsList.vue");
  },
};
